import { render } from "./ProgParentEdit.vue?vue&type=template&id=33d8a428"
import script from "./ProgParentEdit.vue?vue&type=script&lang=js"
export * from "./ProgParentEdit.vue?vue&type=script&lang=js"

import "./ProgParentEdit.vue?vue&type=style&index=0&id=33d8a428&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__